export function sharedValuesSlider() {
    let $slider = $('.shared-values-slider');
    let $counterHolder = $slider.parent();
    let $counterCurrent = $counterHolder.find(".global-counter-current");
    let $counterLength = $counterHolder.find(".global-counter-length");
    $slider.slick({
        infinite: false,
        speed: 700,
        cssEase: 'ease-out',
        dots: true,
        // arrows: false,
        mobileFirst: true,
        adaptiveHeight: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: $counterHolder.find(".global-counter-slider-prev"),
        nextArrow: $counterHolder.find(".global-counter-slider-next"),
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            }
        ]
    }).on('afterChange', function (event, slick, currentSlide, nextSlide) {
        counterSlides();
    });

    function counterSlides() {
        if ($slider.find(".slick-dots li").length > 0) {
            $counterCurrent.parents(".global-counter-slider-wrap").show();
            $counterLength.text($slider.find(".slick-dots li").length);
            $counterCurrent.text($slider.find(".slick-dots li.slick-active").index() + 1);
        } else {
            $counterCurrent.parents(".global-counter-slider-wrap").hide();
        }
    }

    $(window).on("load resize", function () {
        setTimeout(function () {
            counterSlides();
        }, 100);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/sharedValuesSlider.js